import { PromoCustomerSegment } from '@/components/_dashboard/promotion/components/promoCustomerSegment';
import { CommonInput } from '@/components/_dashboard/promotion/formik/commonInput';
import { getBaseInfoValidationList, getPromoFuncType } from '@/components/_dashboard/promotion/tools';
import { getErrorMessage } from '@/utils/stringHelper';
import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { IPromoProps } from '../../type';
import { renderContent, tabContent } from '../tabContent';

export const OfferBaseInfo: React.FC<IPromoProps> = (props) => {
    const { formik, setCanMoveFunc, setFieldTouchedNameFunc } = props;
    const { values } = formik;
    const canMove = useCallback(async () => {
        let message = '';
        let canMove = true;
        try {
            const promoFuncType = getPromoFuncType(values);
            const list = getBaseInfoValidationList(promoFuncType);
            for (const path of list) {
                if (path) {
                    await setFieldTouchedNameFunc(path);
                }
            }
        } catch (e) {
            message = getErrorMessage(e);
            canMove = false;
        }
        return {
            message: message,
            canMove: canMove
        };
    }, [setFieldTouchedNameFunc, values]);

    const wrappedCanMove = useCallback(() => canMove(), [canMove]);
    useEffect(() => {
        setCanMoveFunc(() => wrappedCanMove);
    }, [setCanMoveFunc, wrappedCanMove]);

    const commonContents: tabContent[] = [
        {
            node: (
                <CommonInput
                    formik={formik}
                    fieldPath={'numberOfDeals'}
                    type="number"
                    label="How many deals would you like to publish?"
                    placeholder="Number of Deals"
                />
            )
        },
        {
            node: <></>
        },
        {
            node: <PromoCustomerSegment formik={formik} />
        }
    ];
    return (
        <Grid sx={{ width: '100%' }} container spacing={1}>
            {renderContent(commonContents)}
        </Grid>
    );
};
